import { makeStyles } from 'tss-react/mui';
import { PRODUCT_DETAILS_STICKY_HEADER_Z_INDEX } from '../../consts/productDetailsLayers.consts';

const MEDIA_COLUMN_MAX_WIDTH = '45%';

interface ProductDetailsContentStylesParams {
  galleryColumnWidth: number;
}

export const useProductDetailsContentStyles = makeStyles<ProductDetailsContentStylesParams>()(
  (theme, { galleryColumnWidth }) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      height: '100%',
      minWidth: 0,
      minHeight: 0,
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
      },
    },
    media: {
      position: 'relative',
      flex: '0 0 auto',
      width: galleryColumnWidth,
      maxWidth: MEDIA_COLUMN_MAX_WIDTH,
      height: '100%',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
      [theme.breakpoints.down('lg')]: {
        flex: '0 0 auto',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        height: 'auto',
      },
    },
    content: {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    massActionContainer: {
      position: 'sticky',
      top: 0,
      zIndex: PRODUCT_DETAILS_STICKY_HEADER_Z_INDEX,
      width: '100%',
      height: 0,
    },
    listSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      padding: theme.spacing(1.5, 2),
      [theme.breakpoints.down('lg')]: {
        padding: theme.spacing(1.5),
      },
    },
    list: {
      flex: 1,
      [theme.breakpoints.down('sm')]: {
        marginInline: theme.spacing(-2),
      },
    },
  }),
);
